module.exports = __webpack_public_path__ + "img/23.f10baf30.png";